import AdminPanelLogoImg from "@/assets/adminpanel.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const AdminPanelLogo = (props: Props) => (
  <LogoImage imgSrc={AdminPanelLogoImg} alt="Admin Panel Logo" size="navbar" {...props} />
);
